module.exports = __webpack_public_path__ + "media/img/Scholarships2u-favicon@128-34634855612c4a329364a31b725b74ac.png";